module.exports = __webpack_public_path__ + "img/Isip.fd3b95d4.png";